import { Breadcrumbs, Container, Link, Stack, colors, Typography, Button, Box, Divider, FormControl, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import React from 'react';
import DialogLoading from '../../components/DialogLoading';
import { useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';
import _ from 'lodash';
import PreviewIcon from '@mui/icons-material/Preview';
import { LoadingButton } from '@mui/lab';
import CryptoJS from 'crypto-js';

const RegistrationDetail = ({ userInfo }) => {
  const [loadingState, setLoadingState] = React.useState({});
  const [registration, setRegistration] = React.useState({});
  const [transformed, setTransformed] = React.useState([]);
  const [state, setState] = React.useState({});

  const cookies = new Cookies();

  const params = useParams();
  const id = params.id;

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const getLabel = (key) => {
    const words = key.split('_');

    // Capitalize the first letter of each word and join them with a space
    const formattedString = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    return formattedString;
  };

  const fetchRegistrations = async () => {
    setLoadingState({ ...loadingState, fetch: true });
    if (!id) return toast.error('ID not found');
    fetchWith401Check(`${API_URL}/auth/getregistration/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const _registration = response?.response;
        const _trans = [];
        setRegistration(_registration);
        setState({ ...state, status: _registration.status });

        Object.keys(_registration).forEach((reg) => {
          _trans.push({ id: reg, value: _registration[reg], label: getLabel(reg) });
        });

        setTransformed(_trans);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });

    setLoadingState({ ...loadingState, fetch: false });
  };

  const fetchUser = async () => {
    setLoadingState({ ...loadingState, fetch: true });
    if (!id) return toast.error('ID not found');
    fetchWith401Check(`${API_URL}/auth/user/reg/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        setLoadingState({ ...loadingState, fetch: false });
        const _user = response?.response;
        setState({ ...state, user: _user });
        alert(JSON.stringify(_user));
      })
      .catch(function (err) {
        setLoadingState({ ...loadingState, fetch: false });
        console.log(err);
        // return toast.error(err.message);
      });
  };

  const generateUser = () => {
    const body = {
      username: registration.email_address,
      first_name: registration.first_name,
      type: 'contributor',
      password: registration.password,
      metadata: registration,
      email: registration.email_address,
    };

    if (!body.email) return toast.error('No email found');
    if (!body.username) return toast.error('No username found');

    // const secretKey = process.env.REACT_APP_SKEY;
    // const encrypted = CryptoJS.AES.encrypt(body.password, secretKey).toString();
    // body.password = encrypted;

    setLoadingState({ ...loadingState, create: true });

    fetchWith401Check(`${API_URL}/auth/adduser`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        setLoadingState({ ...loadingState, create: false });
        const _user = response?.response;
        setState({ ...state, user: _user });
      })
      .catch(function (err) {
        setLoadingState({ ...loadingState, create: false });
        if (err.message.includes('409')) return toast.error('Email conflict, please contact administrator');

        toast.error(err.message);
      });
  };

  React.useEffect(() => {
    fetchRegistrations();
  }, []);

  React.useEffect(() => {
    if (state.status === 'verified') fetchUser();
  }, [state.status]);

  const updateRegistration = () => {
    setLoadingState({ ...loadingState, update: true });
    fetchWith401Check(`${API_URL}/auth/update-registration`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({ id: id, status: state.status }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        toast.success('Updated successfully');
        fetchRegistrations();
      })
      .catch(function (err) {
        return toast.error(err.message);
      });

    setLoadingState({ ...loadingState, update: false });
  };
  return (
    <Stack sx={{ backgroundColor: colors.grey[100] }}>
      <Container sx={{ backgroundColor: colors.grey[50] }}>
        <Stack direction='column' sx={{ minHeight: '100vh' }} p={2} spacing={2}>
          <Stack direction='row' spacing={4} alignItems='center'>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link underline='hover' color='inherit' href='/portal'>
                Home
              </Link>
              <Link underline='hover' color='inherit' href='/portal/registrations'>
                Registrations
              </Link>
              <Typography color='text.primary'>Registration Detail</Typography>
            </Breadcrumbs>
          </Stack>

          <Typography variant='h5'>Registration Detail</Typography>

          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <Stack direction='column' spacing={1} sx={{ flex: 1 }}>
              <Typography variant='body2'>First Name: {registration.first_name}</Typography>
              <Typography variant='body2'>Last Name: {registration.last_name}</Typography>
              <Typography variant='body2'>Position: {registration.position}</Typography>
              <Typography variant='body2'>Phone: {registration.phone}</Typography>
              <Typography variant='body2'>Email Address: {registration.email_address}</Typography>
              <Typography variant='body2'>Organization: {registration.organization}</Typography>
            </Stack>

            <Divider orientation='vertical' flexItem />
            {!_.isEmpty(registration) && (
              <Stack direction='column' spacing={2} sx={{ flex: 1 }}>
                <FormControl>
                  <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                    Status
                  </Typography>
                  <RadioGroup
                    value={state.status}
                    onChange={(e) => setState({ ...state, status: e.target.value })}
                    aria-labelledby='demo-radio-buttons-group-label'
                    name='radio-buttons-group'
                  >
                    <FormControlLabel value='new' control={<Radio />} label={<Typography variant='body2'>New</Typography>} />
                    <FormControlLabel value='verified' control={<Radio />} label={<Typography variant='body2'>Verified</Typography>} />
                    <FormControlLabel value='rejected' control={<Radio />} label={<Typography variant='body2'>Rejected</Typography>} />
                  </RadioGroup>
                </FormControl>
                <Box>
                  <LoadingButton
                    loading={loadingState.update}
                    disabled={loadingState.update}
                    onClick={updateRegistration}
                    sx={{ minWidth: 100 }}
                    variant='outlined'
                    size='small'
                  >
                    Update
                  </LoadingButton>
                </Box>
                <Divider />
                {registration.status === 'verified' && (
                  <Stack direction='column' spacing={2}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                      User Info
                    </Typography>
                    <Stack spacing={2}>
                      {state.user ? (
                        <Stack spacing={1}>
                          {/* <Typography variant='body2'>{JSON.stringify(state.user)}</Typography> */}
                          <Typography variant='body2'>Username: {state?.user?.username}</Typography>
                          <Typography variant='body2'>Email: {state?.user?.email}</Typography>
                          {/* <Typography variant='body2'>
                            Password:{' '}
                            <i>
                              password was sent to <b>{state?.user?.email}</b>
                            </i>
                          </Typography> */}
                        </Stack>
                      ) : (
                        <Stack spacing={2}>
                          <Typography variant='body2'>User not yet created</Typography>
                          <Box>
                            <LoadingButton loading={loadingState.create} disabled={loadingState.create} onClick={generateUser} variant='outlined'>
                              Generate User
                            </LoadingButton>
                          </Box>
                        </Stack>
                      )}
                    </Stack>
                  </Stack>
                )}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Container>
      <DialogLoading props={{ show: loadingState.fetch, title: 'Loading', description: 'Please wait ...' }} />
    </Stack>
  );
};

export default RegistrationDetail;
